/* eslint-disable */
import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function ApproveReturnInvoice(props) {

    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: '',
        pageheadername: 'Approve Return Invoice'
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [isTable, setIsTable] = useState(true);
    const [date, setDate] = useState(new Date());

    const [formData, setFormData] = useState({
        groupID: '1',
        operationEntityID: '1',
        dataID: '0'
    });

    function createData(id, collectionCneter, crop, previousQty, additionalQty, totalQty, action) {
        return { id, collectionCneter, crop, previousQty, additionalQty, totalQty, action };
    }

    const rows = [
        createData('1', 'Thanamalvila', 'Ash Plantaion', '200', '50', '250'),
        createData('2', 'Thabuththegama', 'Ash Plantaion', '0', '50', '50'),
        createData('3', 'Boralanda', 'Capsicum', '350', '100', '450')
    ];

    const priceOrderUpdateSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity required'),
        dateID: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            dateID: formData.dataID
        },

        validationSchema: priceOrderUpdateSearchSchema,
        onSubmit: (values) => {
            if (pageProps.isEdit > 0) {
                // SubmitForm();
                setIsTable(true);
            } else {

            }
        }
    });

    async function AppproveInvoice(values) {
        toast.success('Invoice Approved Succesfully');
        setTimeout(() => {
            // navigate('/dashboard');
        }, 3000);
    }

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <Page title="Approve Return Invoice  |  Agri-Connect">
            <Container>
                <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                <FormikProvider value={formik}>
                    <ToastContainer position="bottom-right" pauseOnHover />
                    <Form
                        autoComplete="off"
                        disabled={!(formik.isValid && formik.dirty)}
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Group *"
                                    value={formik.values.groupID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('groupID')}
                                    error={Boolean(touched.groupID && errors.groupID)}
                                    helperText={touched.groupID && errors.groupID}
                                >
                                    <MenuItem key={0} value={0}>
                                        {' '}
                                        Select Group
                                    </MenuItem>
                                    <MenuItem value={1}> Cargills</MenuItem>
                                </TextField>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Operation Entity *"
                                    value={formik.values.operationEntityID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('operationEntityID')}
                                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                    helperText={touched.operationEntityID && errors.operationEntityID}
                                >
                                    <MenuItem key={0} value={0}>
                                        {' '}
                                        Select Operation Entity
                                    </MenuItem>
                                    <MenuItem value={1}> Cargills</MenuItem>
                                </TextField>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Select Date"
                                        value={date}
                                        onChange={(newValue) => {
                                            setDate(newValue);
                                        }}

                                        renderInput={(params) => <TextField
                                            fullWidth
                                            size="small"
                                            {...getFieldProps('date')}
                                            error={Boolean(touched.date && errors.date)}
                                            helperText={touched.date && errors.date}

                                            {...params} />}
                                    />
                                </LocalizationProvider>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="submit" color="secondary" variant="outlined">
                                        Search
                                    </Button>
                                </Stack>
                            </Stack>
                            <br />

                            {isTable ? (
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">Collection Center</TableCell>
                                                            <TableCell align="center">Crop</TableCell>
                                                            <TableCell align="center">Previous Qty(Kg)</TableCell>
                                                            <TableCell align="center">Additional Qty(Kg)</TableCell>
                                                            <TableCell align="center">Total Qty(Kg)</TableCell>
                                                            <TableCell align="center">Action</TableCell>{' '}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : rows
                                                        ).map((row) => (
                                                            <TableRow key={row.id}>
                                                                <TableCell align="center">{row.collectionCneter}</TableCell>
                                                                <TableCell align="center">{row.crop}</TableCell>
                                                                <TableCell align="center">{row.previousQty}</TableCell>
                                                                <TableCell align="center">{row.additionalQty}</TableCell>
                                                                <TableCell align="center">{row.totalQty}</TableCell>
                                                                <TableCell align="center">
                                                                    {row.action}
                                                                    {
                                                                        <IconButton aria-label="delete"
                                                                            onClick={() => AppproveInvoice(row.id)}>
                                                                            <CheckCircleOutlineIcon />
                                                                        </IconButton>
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={6}
                                                                count={rows.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack>
                                    <Divider variant="middle" />
                                </>
                            ) : null}
                        </Stack>
                    </Form>
                </FormikProvider>
            </Container>
        </Page>
    );
}